import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    atmOption: 'ATM Withdrawals',
    errorMessage: 'Oops! There was an unknown error.',
    nfcOption: 'Contactless',
    onlineOption: 'Online Payments',
    successToggleOff: 'The option was successfully deactivated.',
    successToggleOn: 'The option was successfully activated.',
  },
  fr: {
    atmOption: 'Retraits en distributeur',
    errorMessage: 'Oups\u00a0! Une erreur inconnue est survenue.',
    nfcOption: 'Paiement sans contact',
    onlineOption: 'Paiements en ligne',
    successToggleOff: 'L‘option a bien été désactivée.',
    successToggleOn: 'L‘option a bien été activée.',
  },
} as const);

export default locales;
